import {Axios} from "../../../axiosHelper";
import {AxiosError, AxiosResponse} from "axios";
import {metricParamActions} from "../../slice/efe/metricParamSlice";
import {
    AddEventRequest,
    AddMetricParamRequest,
    AddRangeRequest,
    ControlParamListResponse,
    EditEventRequest,
    EditMetricParamRequest,
    EditRangeRequest,
    EventListResponse,
    MetricListParamResponse,
    RangeListResponse
} from "../../data/metricParam";
import {ResponseBase} from "../../data";

export const getControlParamList = (): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setLoading(true));

        Axios.get(`/efe/metric-param/control-param/list`)
            .then((res: AxiosResponse<ControlParamListResponse>) => {
                dispatch(metricParamActions.setControlParamList(res.data.controlParamList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(metricParamActions.setError(resp));
                    }
                }
            });
    };
};


export const getMetricListParam = (cpsTag: string): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setLoading(true));
        console.log("metrics: " + cpsTag);

        Axios.get(`/efe/metric-param/metric/list/${cpsTag}`)
            .then((res: AxiosResponse<MetricListParamResponse>) => {
                dispatch(metricParamActions.setMetricList(res.data.metricList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(metricParamActions.setError(resp));
                    }
                }
            });
    };
};

export const newMetricParam = (cpsTag: string, request: AddMetricParamRequest): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setLoading(true));

        Axios.post(`/efe/metric-param/metric/new/${cpsTag}`, request, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res: AxiosResponse<ResponseBase>) => {
                dispatch(metricParamActions.setResponse(res.data));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(metricParamActions.setResponse(resp));
                        dispatch(metricParamActions.setError(resp));
                    }
                }
            });
    };
};

export const editMetricParam = (request: EditMetricParamRequest): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setLoading(true));

        Axios.put(`/efe/metric-param/metric/edit`, request, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res: AxiosResponse<ResponseBase>) => {
                dispatch(metricParamActions.setResponse(res.data));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(metricParamActions.setResponse(resp));
                        dispatch(metricParamActions.setError(resp));
                    }
                }
            });
    };
};

export const deleteMetricParam = (mtrId: number): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setLoading(true));

        Axios.delete(`/efe/metric-param/metric/delete/${mtrId}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res: AxiosResponse<ResponseBase>) => {
                dispatch(metricParamActions.setResponse(res.data));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(metricParamActions.setResponse(resp));
                        dispatch(metricParamActions.setError(resp));
                    }
                }
            });
    };
};

export const getEventList = (cpsTag: string): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setLoading(true));

        Axios.get(`/efe/metric-param/event/list/${cpsTag}`)
            .then((res: AxiosResponse<EventListResponse>) => {
                dispatch(metricParamActions.setEventList(res.data.eventList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(metricParamActions.setError(resp));
                    }
                }
            });
    };
};

export const newEvent = (cpsTag: string, request: AddEventRequest): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setLoading(true));

        Axios.post(`/efe/metric-param/event/new/${cpsTag}`, request, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res: AxiosResponse<ResponseBase>) => {
                dispatch(metricParamActions.setResponse(res.data));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(metricParamActions.setResponse(resp));
                        dispatch(metricParamActions.setError(resp));
                    }
                }
            });
    };
};

export const editEvent = (request: EditEventRequest): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setLoading(true));

        Axios.put(`/efe/metric-param/event/edit`, request, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res: AxiosResponse<ResponseBase>) => {
                dispatch(metricParamActions.setResponse(res.data));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(metricParamActions.setResponse(resp));
                        dispatch(metricParamActions.setError(resp));
                    }
                }
            });
    };
};

export const deleteEvent = (evtId: number): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setLoading(true));

        Axios.delete(`/efe/metric-param/event/delete/${evtId}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res: AxiosResponse<ResponseBase>) => {
                dispatch(metricParamActions.setResponse(res.data));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(metricParamActions.setResponse(resp));
                        dispatch(metricParamActions.setError(resp));
                    }
                }
            });
    };
};

export const getRangeList = (cpsTag: string): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setLoading(true));

        Axios.get(`/efe/metric-param/range/list/${cpsTag}`)
            .then((res: AxiosResponse<RangeListResponse>) => {
                dispatch(metricParamActions.setRangeList(res.data.rangeList));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(metricParamActions.setError(resp));
                    }
                }
            });
    };
};

export const newRange = (cpsTag: string, request: AddRangeRequest): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setLoading(true));

        Axios.post(`/efe/metric-param/range/new/${cpsTag}`, request, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res: AxiosResponse<ResponseBase>) => {
                dispatch(metricParamActions.setResponse(res.data));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(metricParamActions.setResponse(resp));
                        dispatch(metricParamActions.setError(resp));
                    }
                }
            });
    };
};

export const editRange = (request: EditRangeRequest): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setLoading(true));

        Axios.put(`/efe/metric-param/range/edit`, request, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res: AxiosResponse<ResponseBase>) => {
                dispatch(metricParamActions.setResponse(res.data));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(metricParamActions.setResponse(resp));
                        dispatch(metricParamActions.setError(resp));
                    }
                }
            });
    };
};

export const deleteRange = (ranId: number): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setLoading(true));

        Axios.delete(`/efe/metric-param/range/delete/${ranId}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res: AxiosResponse<ResponseBase>) => {
                dispatch(metricParamActions.setResponse(res.data));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(metricParamActions.setResponse(resp));
                        dispatch(metricParamActions.setError(resp));
                    }
                }
            });
    };
};

export const clearMetricParamResponse = (): any => {
    return async (dispatch: any) => {
        dispatch(metricParamActions.setResponse(null));
    };
};